import type {
  MemberTransactionFilters,
  MemberTransactionFiltersParam
} from '@library/types/members/memberTransactions';
import { useCallback, useState } from 'react';
import type { ComboboxOption } from '@library/components/selects';
import { defaultTransactionFilters } from '@bo-constants/member/memberTransactions';
import { pluck } from 'ramda';

export const useMemberTransactionFilters = () => {
  const [memberTransactionFilters, setMemberTransactionFilters] =
    useState<MemberTransactionFilters>(defaultTransactionFilters);

  const handleChangeMemberTransactionFilters = useCallback(
    ({ key, value }: MemberTransactionFiltersParam) => {
      setMemberTransactionFilters({
        ...memberTransactionFilters,
        [key]:
          key === 'transactionTypes'
            ? pluck('value', value as Array<ComboboxOption>)
            : value
      });
    },
    [memberTransactionFilters, setMemberTransactionFilters]
  );

  const handleResetMemberTransactionFilters = useCallback(() => {
    setMemberTransactionFilters(defaultTransactionFilters);
  }, []);

  return {
    memberTransactionFilters,
    onChangeMemberTransactionsFilter: handleChangeMemberTransactionFilters,
    onResetMemberTransactionFilters: handleResetMemberTransactionFilters
  };
};
